import Style from "./PaypalBtn.module.less";
import {useEffect, useRef, useState} from "react";
import FJLocalStore from "../../store/FJLocalStore";
import mainAction from "../../reducer/action/mainAction";
import FJMessageStore from '../../store/FJMessageStore'
import {useDispatch, useSelector} from "react-redux";
import FJNetworkStore from "../../store/FJNetworkStore";
import loadingIcon from '../../icon/loading.gif'
import FJConfig from "../../config/FJConfig";
import store from "../../reducer/reducer/FJRoot";

let PaypalBtn = (props) => {
    let {isAnnually, style, getPlan, isUpgrade} = props
    let dispatch = useDispatch()
    let {selectPage, currentPlan, dataInfo} = useSelector(state => {
        return {
            selectPage: state.mainReducer.selectPage,
            currentPlan: state.mainReducer.currentPlan,
            dataInfo: state.mainReducer.dataInfo
        }
    })
    let buttons = useRef(null)
    let hasRendered = useRef(false)
    let cityCodeRef = useRef('cn')
    let [hasPop, setHasPop] = useState(false)


    useEffect(() => {
        _getCityCode()
        return () => {
            if (buttons.current && buttons.current.close && hasRendered.current) {
                buttons.current.close();
                hasRendered.current = false
                buttons.current = null
            }
        }
    }, [])
    let _getCityCode = () => {
        try {
            FJNetworkStore.getUserCountryCode().then(countryCode => {
                cityCodeRef.current = countryCode;
            })
        } catch (e) {
        }
    }
    let _getPlan = () => {
        return getPlan()
    }
    let getCookie = (name) => {
        let arr;
        let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr === document.cookie.match(reg))
            return unescape(arr[2]);
        else
            return null;
    }
    let refreshInvoices = () => {
        // 刷新账单列表
        if (window.fj.billing && window.fj.billing.chargeHistory) {
            window.FJGlobalariable.modSubscription.network.updateInvoices().then((res) => {
                if (res.data.length === window.fj.billing.chargeHistory.length) {
                    setTimeout(() => {
                        refreshInvoices()
                    }, 3000);
                } else {
                    window.fj.billing.chargeHistory = res.data;
                }
            }).catch((error) => {
            }).finally(() => {
            });
        }
    }

    window.getSubscribeId = (subscriptionID, boolean) => {
        let total = 0;
        let beginTime = Date.now();
        const plan = _getPlan();
        let _checkSubscription = () => {
            dispatch(mainAction.changeLoadingStatusAction(true))
            window.FJGlobalariable.modSubscription.network.checkoutPaypalSubscriptionStatus(subscriptionID, plan, isUpgrade()).then((res) => {
                let sub_status = res.data.sub_status;
                if (sub_status instanceof Object) {
                    window.FJGlobalariable.modSubscription.updateSubscriptionInfo(sub_status);
                    let lastCurrentPlan;
                    if (plan.teamId) {
                        lastCurrentPlan = {...store.getState().mainReducer.teamSubscription};
                        dispatch(mainAction.setTeamSubscription(sub_status));
                    } else {
                        lastCurrentPlan = {...store.getState().mainReducer.currentPlan};
                        dispatch(mainAction.setCurrentPlan({
                            package: sub_status.package,
                            period: sub_status.period,
                            last4: sub_status.last4,
                            price: sub_status.price,
                            period_end: sub_status.period_end,
                            status: sub_status.status,
                            sub_type: sub_status.sub_type,
                        }));
                    }
                    dispatch(mainAction.setDataInfo({
                        amount: sub_status.amount,
                        coupon: dataInfo.appliedCoupon,
                        transaction_id: sub_status.transaction_id
                    }))
                    window.FJGlobalariable.modSubscription.state.amount = sub_status.amount;
                    window.FJGlobalariable.modSubscription.state.coupon = dataInfo.appliedCoupon;
                    window.FJGlobalariable.modSubscription.state.transaction_id = sub_status.transaction_id;
                    window.FJGlobalariable.modSubscription.state.page = 'successful';
                    dispatch(mainAction.changeLoadingStatusAction(false))
                    dispatch(mainAction.changeStepAction(3))
                    // this.refreshInvoices();
                    refreshInvoices()

                    const state = store.getState().mainReducer;
                    const currentPlan = selectPage === 'team' ?  state.teamSubscription : state.currentPlan;
                    let pay_type = currentPlan.package + '_' + currentPlan.period;
                    let text = 'Create';
                    if ('free' !== lastCurrentPlan.package) {
                        pay_type = lastCurrentPlan.package + '_' + lastCurrentPlan.period + '-' + pay_type;
                        text = 'Upgrade';
                    }

                    // 统计事件
                    if (window.ealog && window.ealog.setUserProperties) {
                        let showSimpleTimeline = getCookie(window.fjuser.info.id + "_close_simple_timeline")
                        let editor_mode = (window.fjuser.info.is_simple_timeline ? 'simple timeline' : (showSimpleTimeline ? 'storyboard' : ''))
                        window.ealog.setUserProperties({'editor mode': editor_mode});
                        if (selectPage === 'team') {
                            window.ealog.setUserProperties({'team type': currentPlan.package + ' ' + currentPlan.period});
                        } else {
                            window.ealog.setUserProperties({'account type': currentPlan.package + ' ' + currentPlan.period});
                        }
                    }

                    window.ealog && window.ealog.addEvent('revenue', {
                        'price': sub_status.amount / 100,
                        'pay_type': pay_type,
                        'is coupon code': !!dataInfo.appliedCoupon,
                        'coupon code off': dataInfo.appliedCoupon && (dataInfo.couponObject.amount_off || dataInfo.couponObject.percent_off),
                        'coupon code': dataInfo.appliedCoupon,
                        'platform': 'paypal',
                    });
                    window.gaEvent('subscription_upgrade', window.FJGlobalariable.modSubscription.entry, '');
                    window.gaPage('subscription/' + pay_type + '.html', 'Subscription ' + text);
                } else if (sub_status === 'failed') {
                    // window.FJGlobalariable.modSubscription.showLoading = false;
                    dispatch(mainAction.changeLoadingStatusAction(false))
                    if (currentPlan.package === 'free') {
                        // window.fjmessage.addMessage(text_('SUB.PLEASE_USE_STRIPE'), 'error');
                        FJMessageStore.addMessage(FJLocalStore._('PLEASE_USE_STRIPE'), 'error');
                    }
                } else {
                    _checkSubscription();
                }

            }).catch(err => {
                let tryAgain = true;
                if (err.type === 'ajax') {
                    total += 1;
                    if (total > 30 && Date.now() > beginTime + 30 * 1000) {
                        tryAgain = false;
                    }
                }
                if (tryAgain) {
                    _checkSubscription(500);
                } else {
                    FJMessageStore.addMessage(FJLocalStore._('CONNECT_NETWORK_FAILED'), 'error');
                    // window.FJGlobalariable.modSubscription.showLoading = false;
                    dispatch(mainAction.changeLoadingStatusAction(false))
                }
            });
        }
        if (boolean) {
            _checkSubscription()
        } else {
        }
    }
    return (
        <>
            <div
                className={Style.paypal_box_new}
                style={style}
                onClick={() => {
                    if (hasPop) {
                        return
                    }
                    setHasPop(true)
                    let requestPath = FJConfig.requestPath
                    let user_info = {
                        browser: window.fjuser ? window.fjuser.getBrowser() : '',
                        geo: cityCodeRef.current,
                        device: window.fjuser ? window.fjuser.getDeviceInfo() : '',
                    };
                    let appliedCoupon = dataInfo.appliedCoupon ? dataInfo.appliedCoupon : ''
                    const plan = _getPlan();
                    const path = plan.teamId ? "/t/subscription/p/create" : "/subscription/pp/createPlan";
                    let query = `?plan=${plan.plan}&coupon=${appliedCoupon}&user_info=${JSON.stringify(user_info)}&upgrade=${isUpgrade()}`;
                    if (plan.teamId) {
                        query += `&teamId=${plan.teamId}&seats=${plan.seats}`;
                    }
                    let test = window.open(requestPath + path + query, "_blank", 'height=600,width=600,status=yes,top=200,left=400,toolbar=no,menubar=no,location=no')
                    test.opener = window
                    let loop = setInterval(function () {
                        if (test.closed) {
                            clearInterval(loop);
                            setHasPop(false)
                        }
                    }, 800)
                }}
            >
                <img width={63} height={20}
                     src="data:image/svg+xml;base64,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"
                     alt=''/>
            </div>
            {hasPop && <div className={Style.mask_box}>
                <div className={Style.mask}/>
            </div>}
        </>


    )
}
export default PaypalBtn